/* eslint-disable */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Banner from '@cpg-its/ads.containers.banner';
import { useHistory } from 'react-router';
import { MapPortalProps } from '../../../models/arc-epi-props';
import { ArcRoutes } from '../../../constants/routes';
import { useBasePath } from '../../../../../global/hooks/useBasePath';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../../../global/components/wysiwyg-with-react-link';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { AdminGhlPendingEnrollment } from '../../new-hire-enrollment/member/models/member-coverage-model';
import { ParticipantsEnrollmentRoutes } from '../../new-participant-enrollment/models/routes';
import { dispatchResetInstitutionClientNumber, dispatchSetCurrentInstitution, setDioceseInstitutionClientNumber, setInstitutionClientNumber, setInstitutionGuid } from '../../institutions/institution-slice';
import { dispatchSetEmployeeList, setCurrentEmployee } from '../../employment/employment-slice';
import { getOrganization } from '../../../../../global/ducks/organization-prc-api';
import { setDioApproverCurrentFormId, setIsLifeEventCoverageForm } from '../../new-hire-enrollment/slice/new-hire-enrollment-slices';
import { AccountInfoRoutes } from '../../../../account-info/constants/routes';
import { getEmployeesList } from '../../../../../global/ducks/benadmin-api';
import { storePendingEnrollmentLocalStorage } from '../../new-hire-enrollment/member/benefit-enrollment/helper/diocese-approver-coverage-helper';
import { EmployeeContext, NavigationContext } from '../../../../../global/models/app-context-model';
import { setEmployeeContext, setNavigationContext } from '../../../../../global/ducks/app-context';
import { useGetCurrentEmployeeFromEmployeeList } from '../../new-hire-enrollment/hooks/useGetCurrentEmployeeFromEmployeeList';
import { useEmploymentInfo } from '../../employment/useEmployment';

interface Props {
    settings: MapPortalProps;
}
export function NewHireAdminPendingGhlEnrollments(props: Props) {
    const { settings } = props;

    const adminPendingGhlEnrollments = useSelector<TcsmStates, AdminGhlPendingEnrollment[]>(state => state?.newHireEnrollmentState?.adminGhlpendingEnrollments);
    const newHirePendingEnrollmentPath = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.DioApproverEnrollment}${ParticipantsEnrollmentRoutes.Coverage}`);
    const newHirePersonalInformationPath = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${AccountInfoRoutes.PersonalInfoSegment}`);

    const history = useHistory();

    const dispatch = useDispatch();

    const handleNavigate = (enrollment: AdminGhlPendingEnrollment) => {

        if (!enrollment?.id) return null;

		dispatch(setDioApproverCurrentFormId(enrollment?.id));
        dispatch(setInstitutionClientNumber(enrollment?.employer?.client_number));
		setDioceseInstitutionClientNumber(enrollment?.diocese?.client_number);
        dispatch(setInstitutionGuid(enrollment?.employer?.client_number));
        dispatch(getOrganization(enrollment?.employer?.client_number, dispatchSetCurrentInstitution(dispatch), dispatchResetInstitutionClientNumber(dispatch)));
		dispatch(setCurrentEmployee({ id: enrollment?.employee?.guid, guid: enrollment?.employee?.guid, employment_id: enrollment?.employment_id, masked_client_number: enrollment?.employee?.masked_client_number }));
        dispatch(getEmployeesList(enrollment?.employer?.client_number, (response) => {
			dispatchSetEmployeeList(dispatch)(response);
		}));
		if (enrollment?.life_event) {
			dispatch(setIsLifeEventCoverageForm(true));
		}

        storePendingEnrollmentLocalStorage(enrollment);
		history.push(newHirePendingEnrollmentPath);
	};

    const handleEmployeeNavigate = (enrollment: AdminGhlPendingEnrollment) => {

        if (!enrollment?.id) return null;

        dispatch(setInstitutionClientNumber(enrollment?.employer?.client_number));
        setDioceseInstitutionClientNumber(enrollment?.diocese?.client_number);
        dispatch(setInstitutionGuid(enrollment?.employer?.client_number));
        dispatch(getOrganization(enrollment?.employer?.client_number, dispatchSetCurrentInstitution(dispatch), dispatchResetInstitutionClientNumber(dispatch)));
        dispatch(setCurrentEmployee({ guid: enrollment?.employee?.guid, employment_id: enrollment?.employment_id, masked_client_number: enrollment?.employee?.masked_client_number }));
        dispatch(setNavigationContext(NavigationContext.Institution));
        dispatch(getEmployeesList(enrollment?.employer?.client_number, (response) => {
			dispatchSetEmployeeList(dispatch)(response);
		}));
        dispatch(setEmployeeContext(EmployeeContext.InstitutionEmployee));
        history.push(newHirePersonalInformationPath);
    };

    const handleBuildUrl = (enrollment: AdminGhlPendingEnrollment) => {
        return (
            <>
                <button className='link-button' type='button' onClick={() => handleNavigate(enrollment)}>{settings?.adminPendingEnrollmentBannerUrlText}</button>
            </>
        );
    };

    const handleBuildEmployeeUrl = (enrollment: AdminGhlPendingEnrollment) => {
        return (
            <>
                <button className='link-button' type='button' onClick={() => handleEmployeeNavigate(enrollment)}>{enrollment?.employee?.name}</button>
            </>
        );
    };

    const handleRenderDescription = (enrollment: AdminGhlPendingEnrollment) => {
        if (!settings?.adminPendingEnrollmentBannerDescription) return null;

        const institutionName = enrollment?.employer?.name || '';
        const employeeName = handleBuildEmployeeUrl(enrollment);
        const linkButton = handleBuildUrl(enrollment);
        const enrollmentLocation = `${enrollment?.employer?.city}, ${enrollment?.employer?.state}`;

        const placeholders = {
            'Institution': institutionName,
            'Link Text': linkButton,
            'Employee name': employeeName,
            'Location': enrollmentLocation,
        };

        const descriptionParts = settings.adminPendingEnrollmentBannerDescription.split(/\[(.*?)\]/g).map((part) => {
            return placeholders[part] || part;
        });

        return (
            <>
                <p>
                    {descriptionParts}
                </p>
            </>
        );
    };

    const sortedLifeEventsFormNewerToOlder = adminPendingGhlEnrollments.slice().sort((a, b) => {
        const firstLifeEvent = new Date(a.approve_by).getTime();
        const secondLifeEvent = new Date(b.approve_by).getTime();
        if (firstLifeEvent === secondLifeEvent) {
            // If dates are equal, sort by the original array index in descending order
            return adminPendingGhlEnrollments.indexOf(b) - adminPendingGhlEnrollments.indexOf(a);
        }
        return secondLifeEvent - firstLifeEvent; // Sort by date in descending order
    });

    return (
        <>
            {sortedLifeEventsFormNewerToOlder?.map((enrollment: AdminGhlPendingEnrollment) => (
                <ContentSpacer>
                    <Banner
                        key={enrollment?.id}
                        banner={{
                            type: 'warning',
                            label: <WysiwygWithReactLink className='input-label' content={settings?.adminPendingEnrollmentBannerTitle} />,
                            description: handleRenderDescription(enrollment),
                        }}
                    />
                </ContentSpacer>
            ))}
        </>
    );

}